import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { addCommasFor } from 'components/vars/common/FormatNumber';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useONonPaymentDetailColDefs = () => {
  const { t } = useTranslation();
  const defaultColDef4 = useMemo((): ColDef => {
    return {
      sortable: true, // 요구사항8번 sortable: true로 변경하면 됨
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  // 요구사항8번 # 제거 및 담당자 및에서 담당부서로 수정
  const colDefs4: any = [
    {
      // headerName: t('com.label.00628', '__Document'),
      // headerTooltip: t('com.label.00628', '__Document'),
      headerName: t('com.label.00122', '__전표번호'),
      headerTooltip: t('com.label.00122', '__전표번호'),
      field: 'slipNo',
      tooltipField: 'slipNo',
      width: 100,
    },
    {
      // 영문은 동일하게 Document Date임
      // headerName: t('com.label.00629', '__Document Date'),
      // headerTooltip: t('com.label.00629', '__Document Date'),
      headerName: t('com.label.00123', '__Document Date'),
      headerTooltip: t('com.label.00123', '__Document Date'),
      field: 'prfDt',
      tooltipField: 'prfDt',
      flex: 1,
    },
    {
      headerName: t('com.label.00630', '__Due Date'),
      headerTooltip: t('com.label.00630', '__Due Date'),
      field: 'dueDt',
      tooltipField: 'dueDt',
      flex: 1,
    },
    {
      headerName: t('com.label.00631', '__Amount'),
      headerTooltip: t('com.label.00631', '__Amount'),
      field: 'payAmt',
      tooltipField: 'payAmt',
      cellStyle: { textAlign: 'right' },
      valueFormatter: (params) => addCommasFor(params.value),
      width: 220,
    },
    {
      headerName: t('com.label.00632', '__Invoice No.'),
      headerTooltip: t('com.label.00632', '__Invoice No.'),
      field: 'invcNo',
      tooltipField: 'invcNo',
      width: 220,
    },
    {
      headerName: t('com.label.00633', '__Reference No.'),
      headerTooltip: t('com.label.00633', '__Reference No.'),
      field: 'rfrnNo',
      tooltipField: 'rfrnNo',
      width: 180,
    },
    {
      // headerName: t('com.label.00634', '__Department'),
      // headerTooltip: t('com.label.00634', '__Department'),
      headerName: t('com.label.00125', '__Department in charge'),
      headerTooltip: t('com.label.00125', '__Department in charge'),
      field: 'mgrDeptNm',
      tooltipField: 'mgrDeptNm',
      width: 300,
    },
    {
      headerName: t('com.label.00635', '__Purchase Order'),
      headerTooltip: t('com.label.00635', '__Purchase Order'),
      field: 'purcOrd',
      tooltipField: 'purcOrd',
      width: 300,
    },
  ];

  return { defaultColDef4, colDefs4 };
};
